import { useCallback, useEffect, useRef, useState } from 'react';
export default function useDebounceOrder(onDebounce, delay = 1000) {
    const debounces = useRef([]);
    const orderValues = useRef([]);
    const [debouncesLength, setDebouncesLength] = useState(0);
    useEffect(() => {
        if (debouncesLength === 0 && orderValues.current.length > 0) {
            onDebounce(orderValues.current);
            orderValues.current = [];
        }
    }, [debouncesLength, onDebounce]);
    useEffect(() => () => {
        // execute onDebouce when leaving page and then clear
        if (orderValues.current.length > 0) {
            onDebounce(orderValues.current);
            orderValues.current = [];
        }
        orderValues.current = [];
        debounces.current.forEach((dbc) => {
            clearTimeout(dbc === null || dbc === void 0 ? void 0 : dbc.debounceFunction);
        });
    }, []);
    const update = useCallback(({ type, specificationId, orderId, orderModelId }) => {
        const newValue = { type, specificationId, orderId, orderModelId };
        orderValues.current.push(newValue);
        if (debounces.current.some((dbcs) => dbcs.id === specificationId)) {
            debounces.current = debounces.current.map((dbc) => {
                if (dbc.id === specificationId) {
                    clearTimeout(dbc.debounceFunction);
                    return Object.assign(Object.assign({}, dbc), { debounceFunction: setTimeout(() => {
                            debounces.current = debounces.current.filter((timeoutDbc) => timeoutDbc.id !== specificationId);
                            setDebouncesLength((dbcsLength) => dbcsLength - 1);
                        }, delay) });
                }
                return dbc;
            });
        }
        else {
            debounces.current.push({
                id: specificationId,
                debounceFunction: setTimeout(() => {
                    debounces.current = debounces.current.filter((timeoutDbc) => timeoutDbc.id !== specificationId);
                    setDebouncesLength((dbcsLength) => dbcsLength - 1);
                }, delay),
            });
            setDebouncesLength((dbcsLength) => dbcsLength + 1);
        }
    }, [delay]);
    return [update];
}
